import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../store';

interface Props {
  dense: boolean;
  includeDev: boolean;
  includeServiceName: boolean;
  searchText: string;
  hoverRowIndex: number | null;
  selectRowIndex: number | null;
  hoverColumnIndex: number | null;
  selectColumnIndex: number | null;
}
export interface SelectedBoxProps {
  row: number | null;
  column: number | null;
}

// Define the initial state using that type
const initialState: Props = {
  dense: true,
  includeDev: false,
  includeServiceName: false,
  searchText: '',
  hoverRowIndex: null,
  selectRowIndex: null,
  hoverColumnIndex: null,
  selectColumnIndex: null,
};

export const serviceMonitorSlice = createSlice({
  name: 'serviceMonitor',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setDense: (state, action: PayloadAction<boolean>) => {
      state.dense = action.payload;
    },
    setIncludeDev: (state, action: PayloadAction<boolean>) => {
      state.includeDev = action.payload;
    },
    setIncludeServiceName: (state, action: PayloadAction<boolean>) => {
      state.includeServiceName = action.payload;
    },
    setSearchText: (state, action: PayloadAction<string>) => {
      state.searchText = action.payload;
    },
    setHoverCell: (state, action: PayloadAction<SelectedBoxProps>) => {
      state.hoverColumnIndex = action.payload.column;
      state.hoverRowIndex = action.payload.row;
    },
    setSelectCell: (state, action: PayloadAction<SelectedBoxProps>) => {
      state.selectColumnIndex = action.payload.column;
      state.selectRowIndex = action.payload.row;
    },
  },
});

export const {
  setDense,
  setIncludeDev,
  setIncludeServiceName,
  setSearchText,
  setSelectCell,
  setHoverCell,
} = serviceMonitorSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectDense = (state: RootState) => state.serviceMonitor.dense;
export const selectIncludeDev = (state: RootState) => state.serviceMonitor.includeDev;
export const selectIncludeServiceName = (state: RootState) =>
  state.serviceMonitor.includeServiceName;
export const selectSearchTextServiceMonitor = (state: RootState) => state.serviceMonitor.searchText;
export const selectSelectBox = (state: RootState): SelectedBoxProps => {
  return {
    row: state.serviceMonitor.selectRowIndex,
    column: state.serviceMonitor.selectColumnIndex,
  };
};
export const selectHoverBox = (state: RootState): SelectedBoxProps => {
  return {
    row: state.serviceMonitor.hoverRowIndex,
    column: state.serviceMonitor.hoverColumnIndex,
  };
};

export default serviceMonitorSlice.reducer;
